var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#123D64"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3551 8.12285L14.2021 9.31275V7.67036C14.2021 7.49257 14.1301 7.32206 14.0019 7.19634C13.8737 7.07063 13.6998 7 13.5186 7H7.36701C7.00446 7 6.65675 7.14125 6.40039 7.39269C6.14402 7.64412 6 7.98514 6 8.34072V13.7036C6 14.0592 6.14402 14.4002 6.40039 14.6516C6.65675 14.9031 7.00446 15.0443 7.36701 15.0443H13.5186C13.6998 15.0443 13.8737 14.9737 14.0019 14.848C14.1301 14.7223 14.2021 14.5518 14.2021 14.374V12.7249L16.3551 13.9148C16.4103 13.9502 16.4741 13.9707 16.54 13.9743C16.6059 13.9778 16.6715 13.9643 16.7304 13.9351C16.7893 13.9059 16.8393 13.862 16.8754 13.8078C16.9115 13.7537 16.9324 13.6911 16.9361 13.6265V8.40776C16.9319 8.34343 16.9105 8.28131 16.8742 8.22759C16.8379 8.17387 16.7878 8.13043 16.729 8.10161C16.6703 8.07278 16.6048 8.05957 16.5392 8.0633C16.4736 8.06703 16.4101 8.08756 16.3551 8.12285Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.baca7e1ef776f97b400dc99d54b3a5d6.svg";
export { ForwardRef as ReactComponent };